interface IconTooltipProps {
    edgeProximity: {
        top: boolean;
        right: boolean;
        bottom: boolean;
        left: boolean;
    };
    id: string;
    isVisible: boolean;
}

const IconTooltip = ({ edgeProximity, id, isVisible }: IconTooltipProps) => (
  <span
    id={id}
    role="tooltip"
    tabIndex={-1}
    className={`absolute z-10 bg-black/70 text-white text-xs rounded py-1 px-2 w-32 transition-opacity duration-100
      ${edgeProximity.right ? 'right-full mr-2' : 'left-5'} 
      ${edgeProximity.top ? 'top-4' : ''} 
      ${edgeProximity.bottom ? 'bottom-4' : ''}
      ${edgeProximity.left ? 'left-full ml-2' : ''}
      whitespace-nowrap text-wrap
      ${isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
    `}
  >
    Click this icon to view race/ethnicity disaggregation and more information
  </span>
);

export default IconTooltip;